export class UserDetailViewModel {
    constructor() {
        this.firstName = " ";
        this.lastName = " ";
        this.emailId = " ";
        this.profileImageURL = "";
        this.organization = "";
        this.organizationId = "";
        this.roles = [];
    }
}
export default class UserDetailView extends UserDetailViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
